import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "templates-tabs",
  class: "templates-tabs uk-tab uk-tab-bottom"
}
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("li", {
        key: tab,
        class: _normalizeClass({ 'uk-active': tab == _ctx.activeTab })
      }, [
        _createElementVNode("a", {
          onClick: ($event: any) => (_ctx.$emit('tabClicked', tab))
        }, _toDisplayString(_ctx.$t(`index_templates.templates_tabs.${tab}`)), 9, _hoisted_2)
      ], 2))
    }), 128))
  ]))
}